export const API_KEY = "AIzaSyDu8AZw0UKIhGlHxVhRtkefn9pD5dYQRsM";

export default API_KEY;